// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/20250416125649/css/" + chunkId + "." + {"766":"b1b80a92","941":"90125017","951":"c9815dc8"}[chunkId] + ".chunk.css";
};